import React from "react";
import { BookingTypePortal } from "../../../modules/booking-engine";
import BookingPremiumWorkspacePanel from "../components/BookingPremiumWorkspacePanel";

export default function BookingDashboardProductPage(): JSX.Element {
  return (
    <>
      <BookingPremiumWorkspacePanel />
      <BookingTypePortal />
    </>
  );
}
